import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
    <footer className="bg-[#111111] text-white py-24 border-t border-[#333] [&~div]:mix-blend-difference [&~div]:border-white/50" data-cursor-invert>
        <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24">
                {/* Brand Column */}
                <div className="col-span-1 md:col-span-1 space-y-8">
                    <h5 className="font-bold text-2xl tracking-tighter text-white">Virtual Beamline</h5>
                    <p className="text-gray-400 text-sm leading-relaxed">
                        A toy simulator for building particle physics intuition. Built for the CERN Beamline for Schools programme.
                    </p>
                </div>

                {/* Platform Column */}
                <div>
                    <h6 className="font-bold text-sm uppercase tracking-widest text-gray-500 mb-6">Explore</h6>
                    <ul className="space-y-4 text-sm text-gray-300">
                        <li><a href="https://simulator.virtualbeamline.org" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Open Simulator</a></li>
                        <li><Link to="/learn" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">Learn</Link></li>
                        <li><Link to="/physics-circles" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">Physics Circles</Link></li>
                        <li><Link to="/team" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">Team</Link></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[#333] pt-12 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
                <p>&copy; 2026 Virtual Beamline. Educational project.</p>
                <a href="mailto:virtualbeamline@gmail.com" className="hover:text-white transition-colors">Contact Us</a>
            </div>
        </div>
    </footer>
);

export default Footer;
